import {
  AuthStatus,
  DivisionList,
  TitleClass,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * 検索フォームの情報
 */
const searchFormList: any = [
  {
    label: "職員氏名",
    keyword: "name",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
  {
    label: "所属課",
    keyword: "mainDivision",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(DivisionList),
  },
  {
    label: "職階",
    keyword: "titleClass",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(TitleClass),
  },
  {
    label: "ステータス",
    keyword: "status",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(AuthStatus),
  },
];

const searchFormSchema = {
  name: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

/**
 * テーブルの情報
 */

const headTitleList: any[] = [
  {
    headTitle: "システム利用者ID",
    className: "tkAnySearchTableResultItem",
    align: "center",
  },
  {
    headTitle: "氏名",
    className: "tkAnySearchTableResultItem",
    align: "center",
  },
  {
    headTitle: "所属課",
    className: "tkAnySearchTableResultItem",
    align: "center",
  },
  {
    headTitle: "所属係",
    className: "tkAnySearchTableResultItem",
    align: "center",
  },
  {
    headTitle: "職階",
    className: "tkAnySearchTableResultItem",
    align: "center",
  },
  {
    headTitle: "権限",
    className: "tkAnySearchTableResultItem",
    align: "center",
    dontNeedSort: true,
  },
  {
    headTitle: "",
    className: "tkAnySearchTableResultItem",
    align: "center",
    dontNeedSort: true,
  },
];

export { headTitleList, searchFormList, searchFormSchema };
